<template>
  <div>
    <vs-popup fullscreen title="Documentation" :active.sync="documentationActive">
      <vs-table stripe :data="moduleCopyProp.return_values" v-if="moduleCopyProp.return_values && moduleCopyProp.return_values.length">
        <template slot="header">
          <h5>
            Return Values
          </h5>
        </template>
        <template slot="thead">
          <vs-th>
            Key
          </vs-th>
          <vs-th>
            Type
          </vs-th>
          <vs-th>
            Description
          </vs-th>
          <vs-th>
            Sample
          </vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data" >
            <vs-td :data="data[indextr].key">
              {{data[indextr].key}}
            </vs-td>
            <vs-td :data="data[indextr].type">
              {{data[indextr].type}}
            </vs-td>
            <vs-td :data="data[indextr].description">
              {{data[indextr].description}}
            </vs-td>
            <vs-td :data="data[indextr].sample">
              {{data[indextr].sample || 'N/A'}}
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vs-popup>
    <vs-popup
      class="editPopup"
      ref="popup"
      :active.sync="editPopup"
      :title="moduleCopyProp.title ? `Edit ${moduleCopyProp.title} - ID: ${moduleCopyProp.id}` : 'Edit your new module'"
    >
      <vs-row>
        <vs-col>
          <vs-input
            name="title"
            label="Module Title"
            v-model="schema.title"
            size="large"
          />
          <json-editor
            :schema="schema"
            :valueProp="value"
            @input="updateValue"
          ></json-editor>
          <vs-row class="pt-4 relative bottom-0" style="display: block;">
            <vs-button v-if="moduleCopyProp.return_values" color="warning" type="filled" @click="documentationActive=true" class="my-2">Documentation</vs-button>
            <vs-button color="primary" type="filled" @click="saveModule" class="my-2 float-right">Save</vs-button>
          </vs-row>
        </vs-col>
      </vs-row>
    </vs-popup>

  </div>

</template>
<script>
import jsonEditor from './jsonEditor.vue'
import _ from 'lodash'

export default {
  name: 'edit-popup',
  props: ['moduleCopyProp', 'editPopupProp'],
  components: {'json-editor': jsonEditor},
  data () {
    return {
      schema: {},
      value: {},
      documentationActive: false
    }
  },
  mounted () {
    const $this = this
    $this.$set($this, 'schema', $this.moduleCopyProp.options_schema)
    $this.$set($this, 'value', $this.moduleCopyProp.value)
    $this.getOptionsSchema()
  },
  watch: {
    editPopup (val) {
      if (val && this.moduleCopyProp) {
        console.log('WATCHER RUN')
        const $this = this
        $this.$set($this, 'schema', $this.moduleCopyProp.options_schema)
        console.log('WATCHER —— setting value', $this.moduleCopyProp.value)
        $this.$set($this, 'value', $this.moduleCopyProp.value)
        $this.getOptionsSchema()
      }
    }
  },
  computed: {
    editPopup: {
      get () {
        return this.editPopupProp
      },
      set () {
        if (this.editPopupProp) {
          this.$emit('updateEditPopupState', !this.editPopupProp)
        }
      }
    }
  },
  methods: {
    getOptionsSchema () {
      const $this = this

      const m = _.cloneDeep($this.moduleCopyProp)

      $this.$emit('updateFocusedModule', m)
      $this.$set($this, 'schema', $this.moduleCopyProp)
      /*if (!$this.moduleCopyProp.options_schema.properties) {
        $this.$http({
          method: 'get',
          url: `${process.env.VUE_APP_API_ENDPOINT}/module/${$this.moduleCopyProp.name}/${$this.moduleCopyProp.latestVersion}/scenarios`,
          headers: { 'Authorization': `Bearer ${localStorage.jwt}` }
        })
          .then(response => {
            const m = _.cloneDeep($this.moduleCopyProp)
            m.options_schema = response.data[0].options_schema

          })
          .catch((err) => console.log('api error occured', err))
      }*/
    },
    saveModule () {
      console.log('saveModule()')
      const $this = this
      const m = _.cloneDeep($this.moduleCopyProp)
      m.options_schema = $this.schema
      m.value = $this.value

      $this.$emit('updateModule', m)
      $this.$emit('saveClik')
      this.$emit('updateEditPopupState', !this.editPopupProp)
    },
    updateValue (val) {
      const $this = this
      $this.value = val
    }
  }
}
</script>
<style scoped>
  div.jsoneditor-tree {
    padding-bottom: 10em !important;
  }
</style>
